import React from 'react';
import { motion } from 'framer-motion';
export function AboutLaura() {
  return <section className="w-full bg-white py-24 px-6" data-id="element-19">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative w-full max-w-md mx-auto lg:max-w-none order-2 lg:order-1" data-id="element-21">
          <div className="aspect-square rounded-full overflow-hidden relative shadow-xl max-w-md mx-auto" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/1kkrwSyB39ix77K5vVgHza/Me.jpg" alt="Laura" className="object-cover w-full h-full" data-id="element-23" />
            <div className="absolute inset-0 bg-teal/5 mix-blend-overlay" data-id="element-24"></div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2" data-id="element-25">
          <h2 className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl mb-10" data-id="element-26">
            Quién está detrás de este trabajo
          </h2>

          <div className="space-y-6 text-lg text-gray-700 font-light leading-relaxed" data-id="element-27">
            <p data-id="element-28">
              Empecé este camino para ayudar a otros.
              <br data-id="element-29" />
              Eso era claro. Eso era genuino.
            </p>
            <p data-id="element-30">
              Pero lo que no sabía —<br data-id="element-31" />
              lo que nadie me podría haber anticipado —<br data-id="element-32" />
              era la magnitud de lo que estaba a punto de abrirse.
            </p>
            <p data-id="element-33">
              En el transcurso de un año,
              <br data-id="element-34" />
              bajó una cantidad de información que todavía me cuesta
              dimensionar.
              <br data-id="element-35" />
              No aprendí sobre energías. Las entendí desde adentro.
              <br data-id="element-36" />
              No estudié sobre planos y dimensiones. Los recorrí.
            </p>
            <p data-id="element-37">
              Y en el medio de todo eso —<br data-id="element-38" />
              las personas que vinieron a buscar ayuda
              <br data-id="element-39" />
              me enseñaron tanto como cualquier otra fuente.
              <br data-id="element-40" />
              Porque este trabajo fluye en las dos direcciones.
            </p>
            <p data-id="element-41">
              Mi transformación fue radical.
              <br data-id="element-42" />
              No como metáfora. Como hecho concreto e irreversible.
              <br data-id="element-43" />
              Y esa transformación es la que está detrás
              <br data-id="element-44" />
              de cada sesión que realizo.
            </p>
            <p className="font-serif italic text-xl text-teal mt-8" data-id="element-45">
              Hay cosas que no se aprenden.
              <br data-id="element-46" />
              Se atraviesan.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}